<template>
  <div>
    <div class="boolArea">
      <v-row>
        <v-col cols="6" lg="6" v-for="(item , i ) in items" :key="i" style="cursor: pointer">
          <div class="selectableItem  d-flex flex-column justify-space-around" :id="item.id" @click="setRadioSelected(item.id)"
               :class="radioSelected == item.id && 'activeOption'"
          >
            <template v-if="$vuetify.rtl">
              {{ item.text }}
            </template>
            <template v-else>
              {{ item.en_text }}
            </template>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-btn class="confirmBtn mt-5" block color="#3CBE8B" elevation="0" id="confirm_btn" @click="changes"
           v-if="$vuetify.breakpoint.lgAndUp">
      {{ $t('matchMaking.buttons.submit') }}
    </v-btn>
  </div>
</template>

<script>

export default {
  props: {
    items: Array,
    language: {
      default: 'fa'
    },
    callChangeInOption: Boolean,
  },
  data() {
    return {
      radioSelected: null,
    }
  },
  methods: {
    setRadioSelected(id) {
      this.radioSelected = id
    },
    changes() {
      if (this.radioSelected) {
        this.$emit('answerHandler', [
          {
            'question_option_id': this.radioSelected,
          },
        ])
      } else {
        this.$emitEvent('notify', {color: 'red', title: this.$t('matchMaking.pleaseAnswer')});
      }
    }
  },
  watch: {
    callChangeInOption(val) {
      if (val) {
        this.changes()
      }
    }
  }
}

</script>

<style scoped>
.selectableItemArea {
  min-height: 66px;
}
@media (min-width: 200px) and (max-width: 800px) {
  .selectableItem {
    min-height: 100px !important;
  }
}


.selectableItem {
  display: flex;
  height: 80px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 8px;
  border: 2px solid transparent;
  box-shadow: inset 0 0 0 1px #E1E1E1;
  background: #FFF;
  transition: all 0.3s;
  cursor: pointer;
  margin-bottom: 13px;
  text-align: center;
}

.activeArea {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #4576d8;
}

.activeItem {
  border: 3px solid #4576d8;
}

.numeriArea {
  width: 70%;
  margin: auto;
}

.textSelectBox {
  line-height: 20pt;
  padding: 10px;
}

.selectableItem:hover {
  transition: all 0.3s;
  border-color: #39C990 !important;
  //background: linear-gradient(180deg, #FFF 0%, rgba(215, 244, 233, 0.80) 100%) !important;
}

.activeOption {
  border: 2px solid #39C990;
  box-shadow: none;
  //background: linear-gradient(180deg, #FFF 0%, rgba(215, 244, 233, 0.80) 100%) !important;
}
</style>
